<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Performance"></app-breadcrumb>

        <!-- resume here -->
        <!-- performance -->
        <div class="row mb-3">
            <div class="col-md-4 col-12">
                <h3>Performance</h3>
            </div>
            <div class="col-md-8 col-12">
                <ul class="nav nav-tabs nav-settings">
                    <li @click="showViews" class="nav-item">
                        <router-link class="nav-link" to="?views">Views</router-link>
                    </li>
                    <li @click="showShoppers" class="nav-item">
                        <router-link class="nav-link" to="?shoppers">Shoppers</router-link>
                    </li>
                    <li @click="showItems" class="nav-item">
                        <router-link class="nav-link" to="?items">Items</router-link>
                    </li>
                    <li @click="showPromotions" class="nav-item">
                        <router-link class="nav-link" to="?promotions">Promotions</router-link>
                    </li>
                    <li @click="showRevenue" class="nav-item">
                        <router-link class="nav-link" to="?revenue">Revenue</router-link>
                    </li>
                </ul>
            </div>  
        </div>

        <!-- show views -->
        <app-views v-if="viewsTab"></app-views>

        <!-- show shoppers -->
        <app-shoppers v-if="shoppersTab"></app-shoppers>

        <!-- show items -->
        <app-items v-if="itemsTab"></app-items>

        <!-- show promotions -->
        <app-promotions v-if="promotionsTab"></app-promotions>

        <!-- show revenue -->
        <app-revenue v-if="revenueTab"></app-revenue>
    </div>
</template>

<script>
import Views from './performanceParts/Views.vue'
import Shoppers from './performanceParts/Shoppers.vue'
import Items from './performanceParts/Items.vue'
import Promotions from './performanceParts/Promotions.vue'
import Revenue from './performanceParts/Revenue.vue'
import Breadcrumb from '../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Performance",
    data() {
        return {
            viewsTab: true,
            shoppersTab: false,
            itemsTab: false,
            promotionsTab: false,
            revenueTab: false
        }
    },
    methods: {
        showViews() {
            this.shoppersTab = this.itemsTab = this.promotionsTab = this.revenueTab = false
            this.viewsTab = true
        },
        showShoppers() {
            this.viewsTab = this.itemsTab = this.promotionsTab = this.revenueTab = false
            this.shoppersTab = true
        },
        showItems() {
            this.shoppersTab = this.viewsTab = this.promotionsTab = this.revenueTab = false
            this.itemsTab = true
        },
        showPromotions() {
            this.shoppersTab = this.itemsTab = this.viewsTab = this.revenueTab = false
            this.promotionsTab = true 
        },
        showRevenue() {
            this.shoppersTab = this.itemsTab = this.promotionsTab = this.viewsTab = false
            this.revenueTab = true 
        }
    },
    components: {
        appViews: Views,
        appShoppers: Shoppers,
        appItems: Items,
        appPromotions: Promotions,
        appRevenue: Revenue,
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.$emit('update:layout', LayoutShop);
    }
}
</script>